var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjectInformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66666 8.33337H18.3333M1.66666 15V5.00004C1.66666 4.07957 2.41285 3.33337 3.33332 3.33337H5.9763C6.41833 3.33337 6.84225 3.50897 7.15481 3.82153L7.84517 4.51189C8.15773 4.82445 8.58165 5.00004 9.02368 5.00004H16.6667C17.5871 5.00004 18.3333 5.74623 18.3333 6.66671V15C18.3333 15.9205 17.5871 16.6667 16.6667 16.6667H3.33332C2.41285 16.6667 1.66666 15.9205 1.66666 15Z",
    stroke: "#026735",
    strokeWidth: 1.67,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectInformation);
export default __webpack_public_path__ + "static/media/projectInformation.ecf7a0fac2a415434739bd634a3a4f17.svg";
export { ForwardRef as ReactComponent };